/**
 * Fill-if-absent pass for @client local-state defaults.
 *
 * The defaults in client.js are only written when NO persisted cache blob
 * exists, and the blob is restored wholesale over the in-memory cache. That
 * leaves a gap: any blob persisted before a local-state field existed (an old
 * visitor returning after a deploy that added a new @client field, or a
 * hand-seeded blob like the visual tests') restores WITHOUT that field, the
 * defaults never get written, and unguarded reads crash on every Layout
 * render. This pass runs after restore and writes the default for exactly the
 * entries the cache cannot fulfil, leaving present values untouched.
 *
 * Note: readQuery returns null for a PARTIALLY fulfilled query too, so a blob
 * holding an old shape of an entry (missing one new subfield) gets the whole
 * default written over it. Losing a guest's stale pre-upgrade referral state
 * in that edge is acceptable; crashing is not.
 */
export const writeMissingCacheDefaults = (cache, entries) => {
  entries.forEach(({ query, data }) => {
    let existing = null;
    try {
      existing = cache.readQuery({ query });
    } catch {
      existing = null;
    }
    if (existing == null) {
      cache.writeQuery({ query, data });
    }
  });
};
